import { handleActions } from "redux-actions";
import { fromJS } from "immutable";
import types from "../types";

const INITIAL_STATE = fromJS({
  isLoading: false,
  isLoadingOptions: false,
  data: [],
  dataSub: [],
  message: "",
});

const reducer = handleActions(
  {
    [types.GET_OPTIONS]: (state) => state.set("isLoadingOptions", true),
    [types.GET_OPTIONS_FAIL]: (state) => state.set("isLoadingOptions", false),
    [types.GET_OPTIONS_SUCCESS]: (state, { payload: response }) =>
      state.set("isLoadingOptions", false).set("data", response.data),
    [types.GET_SUB_OPTIONS]: (state) => state.set("isLoadingOptions", true),
    [types.GET_SUB_OPTIONS_FAIL]: (state) =>
      state.set("isLoadingOptions", false),
    [types.GET_SUB_OPTIONS_SUCCESS]: (state, { payload: response }) =>
      state.set("isLoading", true).set("dataSub", response.data),
    [types.REGISTER]: (state) => state.set("isLoading", true),
    [types.REGISTER_FAIL]: (state) => state.set("isLoading", false),
    [types.REGISTER_SUCCESS]: (state, { payload: response }) =>
      state.set("isLoading", false).set("message", response.data.message),
  },
  INITIAL_STATE
);

export default reducer;
